import React from 'react';
import { Provider } from 'react-redux';
import { createReactRenderer } from 'helpers/react-renderer';
import store from 'pages/store';

import VendorReturnCreate from 'pages/views/inventory/VendorReturns/VendorReturnCreate';

const StoreWrappedConnectedVendorReturnModal = props => (
  <Provider store={store}>
    <VendorReturnCreate {...props} />
  </Provider>
);

export default StoreWrappedConnectedVendorReturnModal;

const RenderedComponent = createReactRenderer({
  component: StoreWrappedConnectedVendorReturnModal,
  selector: '[data-react-root="CreateVendorReturn"]',
});

history.onChangeState(
  { name: 'vendor_return.listings.vendor_returns' },
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
